<template>
  <Ethereum :callback="initialize" />
  <div class="confirmBurn">
    <div class="container">
      <div class="descriptionWrapper">
        <div class="title">Confirm Claim</div>
        <div>Please confirm you want to claim these Rickstro Bulls.</div>
        <div class="warning" v-if="selectedFrens.length >= 50">
          We recommend a max claim of 50 Bulls per transaction.
        </div>
      </div>

      <div class="itemsGrid">
        <NFTCard
          :fren="fren"
          v-for="fren in selectedFrens"
          :key="fren.id"
          :class="fren.isSelected ? 'selected' : ''"
        />
      </div>
      <div class="burnButtonWrapper">
        <Button @click="confirmClaim">
          Confirm Claim {{ selectedFrens.length }}
        </Button>
        <div class="cancel" @click="router.go(-1)">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>
'use strict';

// Imports.
import { ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

// Component imports.
import NFTCard from '../my-frens/components/NFTCard.vue';
import Ethereum from '/src/components/common/Ethereum.vue';
import Button from '/src/components/ui/Button.vue';

// Icon imports.

export default {
  components: {
    NFTCard,
    Ethereum,
    Button
  },

  props: ['frens'],

  setup(props) {
    const store = useStore();
    const selected = ref();
    const router = useRouter();

    const loading = ref(false);
    if (store.state.mint.frens.length === 0) loading.value = true;
    // Once the state variable changes, the watch is triggered.
    watch(
      () => store.state.mint.frens,
      selection => {
        loading.value = false;
      }
    );

    // Retrieve the the user's owned frens.
    const initialize = () => {
      const address = store.state.ethers.address;

      let astrofrens = '0x71B11Ac923C967CD5998F23F6dae0d779A6ac8Af'; // mainnet bulls
      // let astrofrens = '0x323F1569fB3e276f6e39Be3008e43150e8467c0d'; // rinkeby bulls
      const groupId = 1;
      store.dispatch(
        'mint/getFrens',
        { address, collectionAddress: astrofrens, groupId },
        { root: true }
      );
    };

    const selectedFrens = computed(() => {
      let frenIds = new Set(props.frens);

      return store.state.mint.frens.filter(fren => frenIds.has(fren.id));
    });

    const confirmClaim = () => {
      let ids = [];
      for (let i = 0; i < selectedFrens.value.length; i++) {
        ids.push('0x' + selectedFrens.value[i].id);
      }
      // let rickAddress = '0x2c4062D19F8581B377208b3AB6a52EF2f8c75756'; // rinkeby rick
      // let astrofrens = '0x323F1569fB3e276f6e39Be3008e43150e8467c0d'; // rinkeby bulls
      let rickAddress = '0xc7b9D8483FD01C379a4141B2Ee7c39442172b259'; // mainnet rick
      store.dispatch(
        'burn/burn',
        { ids, address: rickAddress },
        { root: true }
      );
      const groupId = 1;
      const address = store.state.ethers.address;
      // let astrofrens = '0x323F1569fB3e276f6e39Be3008e43150e8467c0d'; // rinkeby bulls
      let astrofrens = '0x71B11Ac923C967CD5998F23F6dae0d779A6ac8Af'; // mainnet bulls

      store.dispatch(
        'mint/getFrens',
        { address, collectionAddress: astrofrens, groupId },
        { root: true }
      );
    };

    return {
      store,
      initialize,
      loading,
      selected,
      selectedFrens,
      confirmClaim,
      router
    };
  }
};
</script>
<style scoped lang="scss">
.confirmBurn {
  padding: 60px 20px;
  color: white;

  .container {
    width: 1800px;
    max-width: 90%;
    margin-right: auto;
    margin-left: auto;

    .descriptionWrapper {
      display: flex;
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .title {
        margin-top: 0px;
        margin-bottom: 20px;
        font-family: Montserrat, sans-serif;
        color: #ffd915;
        font-size: 90px;
        line-height: 1em;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
      }

      .warning {
        background-color: red;
        padding: 10px;
        font-weight: bold;
      }
    }

    .itemsGrid {
      display: grid;
      width: 100%;
      justify-content: center;
      justify-items: center;
      grid-auto-columns: 1fr;
      grid-auto-rows: 1fr;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: repeat(auto-fit, minmax(300px, min-content));
      grid-template-rows: 1fr;
    }

    .burnButtonWrapper {
      position: sticky;
      left: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 5;
      display: grid;
      min-height: 60px;
      margin-bottom: 40px;
      padding: 120px 30px;
      justify-content: center;
      justify-items: center;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      grid-template-columns: auto;
      grid-template-rows: auto;
      background-image: linear-gradient(0deg, #000 50%, transparent);

      .cancel {
        transition: opacity 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
        color: #fff;
        opacity: 0.6;
        font-size: 20px;
        text-decoration: none;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        &:active {
          opacity: 1;
        }
      }
    }
  }
}
</style>
